const mainActions = [
  { action: "newEvent", value: null, type: "main" },
  { action: "newPlayId", value: null, type: "main" },
  { action: "saveData", value: "videoReview", type: "eventType" },
  {
    action: "saveData",
    value: "instantReplaySystem",
    type: "subType",
  },
  {
    action: "saveData",
    value: [{ option: "status", value: "PENDING" }],
    type: "options",
  },
  {
    action: "saveData",
    value: ["periodId", "clock"],
    type: "variables",
  },
  { action: "sendEvent", value: "new", type: "main" },

  { action: "copyEvent", value: "irs", type: "to" },
  { action: "clearData", value: ["options"], type: "main" },

  {
    action: "nextState",
    value: "coach-challenge-reason",
    type: "primary",
  },
];

export const TeamSelect = {
  name: "team-select",
  component: "MainPanel",
  layout: "main-panel large padded align-center",
  mode: "visible",
  text: "irs.select-team",
  showOn: [{ state: "primary", value: "team-select", operator: "is" }],
  allowCancel: true,
  children: [
    {
      name: "team-0-irs",
      component: "TypeButton",
      layout: "match-button",
      mode: "enable",
      text: { team: "name" },
      showOn: [true],
      options: { team: 0 },
      actionGroups: [
        {
          actions: mainActions,
          conditions: [],
        },
      ],
    },
    {
      name: "team-1-irs",
      component: "TypeButton",
      layout: "match-button",
      mode: "enable",
      text: { team: "name" },
      showOn: [true],
      options: { team: 1 },
      actionGroups: [
        {
          actions: mainActions,
          conditions: [],
        },
      ],
    },
  ],
};
